import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Labs is gone: stablecoin trading, its only experiment, is live. Old links
 * and bookmarks land on the exchange instead.
 */
export const Route = createFileRoute("/(app)/_main-layout/_labs/labs")({
  beforeLoad: ({ search }) => {
    const { applicationId } = search as { applicationId?: string };
    throw redirect({
      to: "/exchange",
      search: applicationId ? { applicationId } : {},
      replace: true,
    });
  },
});
